// Trailer-load's web-session configuration (shared session layer, see
// src/shared/session/README.md). Only existing REACT_APP_* variables.

import { configureSession } from "./shared/session";

export const sessionConfig = configureSession({
  app: "trailer-load",
  apiUrl: process.env.REACT_APP_API_URL || "",
  admiralUrl: process.env.REACT_APP_ADMIRAL_APP || "",
  domainName: process.env.REACT_APP_DOMAIN_NAME || "",
  userPoolId: process.env.REACT_APP_USERPOOL_ID || "",
  clientId: process.env.REACT_APP_CLIENT_ID || "",
  // optional (localhost); defaults to https://app.<REACT_APP_DOMAIN_NAME>
  sessionApiUrl: process.env.REACT_APP_SESSION_API_URL || undefined,
});
